enum WebWorkerType {
	APPLET_TIMING_CONTROLLER = 0,
}

export default WebWorkerType;
